/* jshint esnext:true */

const createStore = require('fluxible/addons/createStore');

export default createStore({
    storeName: 'FormStore',

    initialize() {
        this._fieldValues = {};
        this._fieldErrors = {};
        this._formErrors = [];
        this._data = null;
        this._isSubmitting = false;
        // is true if either client/server validation errors or if unexpected error
        this._submitFailed = false;
    },

    handlers: {
        FORM_SUBMIT: 'onSubmit',
        FORM_SUBMIT_SUCCESS: 'onSubmitSuccess',
        FORM_SUBMIT_FAILURE: 'onSubmitFailure',

        FORM_VALIDATION_ERROR: 'onValidationErrors',

        FORM_CLEAR: 'onClear',
    },

    onSubmit(fieldValues) {
        this._fieldValues = fieldValues;
        this._isSubmitting = true;
        this._submitFailed = false;
        this._fieldErrors = {};
        this._formErrors = [];
        this.emitChange();
    },

    onClear() {
        this.initialize();
        this.emitChange();
    },

    /**
     * After sucess, reset data. Optionaly action can forward response body in
     * case there is some data that will be needed
     *
     * @arg {Object} [responseBody]
     */
    onSubmitSuccess(responseBody = {}) {
        this._fieldErrors = {};
        this._formErrors = [];
        this._isSubmitting = false;
        this._data = responseBody.data;
        this.emitChange();
    },

    /**
     * @arg {Object} [response] - error response object returned from ajax call.
     * If it is missing we assume it was some unexpected error which
     * should be handled by default error handler.
     * @arg {Object} [response.fieldErrors]
     * @arg {[string]} [response.formErrors]
     * @arg [response.data] - arbitrary data, used for some special case form handling.
     * Like shiwing different captcha on bad request.
     */
    onSubmitFailure(response) {
        if (response) {
            const {fieldErrors, formErrors, data} = response;
            this._fieldErrors = fieldErrors || {};
            this._formErrors = formErrors || [];
            this._data = data;
        }
        this._submitFailed = true;
        this._isSubmitting = false;
        this.emitChange();
    },

    onValidationErrors({fieldErrors, formErrors}) {
        this._fieldErrors = fieldErrors;
        this._formErrors = formErrors;
        this._isSubmitting = false;
        this._submitFailed = true;
        this.emitChange();
    },

    getDefaultData() {
        return {
            fieldValues: this._fieldValues,
            fieldErrors: this._fieldErrors,
            formErrors: this._formErrors,
            isSubmitting: this._isSubmitting,
            submitFailed: this._submitFailed,
            data: this._data,
        };
    },
});
